import { useSearchParams } from "react-router-dom";
import { DeliveryStatusEnum } from "@/constants/enums/deliveryStatus.enum";
import { DeliveryStatusBadge } from "../shared/badge/deliveryStatus.badge";

type TrackingHeaderProps = {
  code: string;
  status: string;
};

export const TrackingHeader = ({ code, status }: TrackingHeaderProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const locale = searchParams.get("locale") || "fr";

  const setLocale = (locale: string) => {
    const updatedParams = new URLSearchParams(searchParams);
    updatedParams.set("locale", locale);
    setSearchParams(updatedParams);
  };

  return (
    <div className="flex w-full flex-col items-start gap-3">
      <div className="flex w-full flex-row items-center justify-between gap-2">
        <div className="flex flex-col items-start gap-4 lg:flex-row lg:items-center">
          <h1 className="text-lg font-semibold lg:text-2xl">
            {locale === "fr" ? "Suivi de l'expédition" : "Tracking"} C-{code}
          </h1>
          <DeliveryStatusBadge type={status as DeliveryStatusEnum} />
        </div>
        <div className="flex flex-row">
          <button
            onClick={() => setLocale("fr")}
            className={`${locale === "fr" ? "border-brand600 text-brand600 border-0 border-b-2" : "text-black"} rounded-none px-4 py-2 focus:outline-hidden`}
          >
            FR
          </button>
          <button
            onClick={() => setLocale("en")}
            className={`${locale === "en" ? "border-brand600 text-brand600 border-0 border-b-2" : "text-black"} rounded-none px-4 py-2 focus:outline-hidden`}
          >
            EN
          </button>
        </div>
      </div>
      <h2 className="text-base text-gray-600">
        {locale === "fr"
          ? "Vous trouverez les informations liées à la livraison de votre commande"
          : "You will find the information related to the delivery of your order"}
      </h2>
    </div>
  );
};
